import React, { useState, useEffect, useContext } from "react";
import Form from "react-bootstrap/Form";
import BannerSection from "../../inc/BannerSection";
import Banner from "../../images/banner.jpg";

import Button from "react-bootstrap/Button";
import { Link } from "react-router-dom";
import TherapistSidebar from "../../inc/TherapistSidebar";
import { FaAlignLeft } from "react-icons/fa";
import { AuthContext } from "../../../utility/services/AuthContext";
import ApiService from "../../../utility/services/ApiService";
import Functions from "../../../utility/services/Functions";
import { toast } from "react-toastify";
import { loadStripe } from "@stripe/stripe-js";
import ReactLoader from "react-js-loader";
import {
  useStripe,
  useElements,
  Elements,
  CardNumberElement,
  CardExpiryElement,
  CardCvcElement,
} from "@stripe/react-stripe-js";

const env_config = process.env;
const isProduction = env_config.REACT_APP_PRODUCTION_MODE == "true";
const STRIPE_PUBLIC_KEY = isProduction
  ? env_config.REACT_APP_STRIPE_PUBLIC_KEY_LIVE
  : env_config.REACT_APP_STRIPE_PUBLIC_KEY_TEST;
const stripePromise = loadStripe(STRIPE_PUBLIC_KEY);

const PaymentSettings = () => {
  // LOGICAL VARIABLES

  const [filterHideShow, setfilterHideShow] = useState(false);
  const { setLoading } = useContext(AuthContext);
  const [showCardFields, setShowCardFields] = useState(false);
  const [initial_loading, setInitialLoading] = useState(false);

  const { create_card, get_card_list, set_default_card, delete_card } =
    ApiService();
  const { consoleService, capitalizeFirstLetter, getCardBrandIconPath } =
    Functions();

  // DATA VARIABLES

  const [cardList, setCardList] = useState([]);
  // USE EFFECTS

  useEffect(() => {
    getCardListFun();
  }, []);

  // FUNCTIONS

  const sideBarHide = () => {
    setfilterHideShow(!filterHideShow);
  };

  const getCardListFun = async () => {
    setLoading(true);
    try {
      const res = await get_card_list();
      if (res.status === 1) {
        setCardList([...res.data]);
        const isCardFound = res.data.length > 0;
        if (isCardFound) {
          setShowCardFields(false);
        } else {
          setShowCardFields(true);
        }
        setInitialLoading(true);
        setLoading(false);
      } else {
        setLoading(false);
        toast(res.message, {
          position: "top-center",
          hideProgressBar: true,
          type: "error",
        });
      }
    } catch (err) {
      setLoading(false);
      consoleService("Error in getCardDetailsFun function = ", err);
    }
  };

  const set_default_card_fun = async (card_id) => {
    try {
      setLoading(true);
      setShowCardFields(false);
      const res = await set_default_card({
        card_id,
      });
      if (res.status === 1) {
        getCardListFun();
      } else {
        setLoading(false);
        toast(res.message, {
          position: "top-center",
          hideProgressBar: true,
          type: "error",
        });
      }
    } catch (err) {
      setLoading(false);
      consoleService("Error in set_default_card_fun function = ", err);
    }
  };

  const delete_card_fun = async (card_id) => {
    try {
      setLoading(true);
      const res = await delete_card({
        card_id,
      });
      if (res.status === 1) {
        getCardListFun();
      } else {
        setLoading(false);
        toast(res.message, {
          position: "top-center",
          hideProgressBar: true,
          type: "error",
        });
      }
    } catch (err) {
      setLoading(false);
      consoleService("Error in delete_card_fun function = ", err);
    }
  };

  async function handle_add_card_fun() {
    setShowCardFields(true);
  }

  // STRIPE COMPONENT

  const StripForm = () => {
    const [name, setName] = useState("");
    const [isCardNumberValid, setIscardValid] = useState(false);
    const [isExpiryCardValid, setIsExpiryCardValid] = useState(false);
    const [isCvcValid, setIsCvcValid] = useState(false);
    const [stripe_loading, setStripeLoading] = useState(false);
    const stripe = useStripe();
    const elements = useElements();

    const submitFun = async (paymentMethodId) => {
      const res = await create_card({
        paymentMethodId,
      });
      try {
        if (res.status === 1) {
          toast("Card added successfully", {
            position: "top-center",
            hideProgressBar: true,
            type: "success",
          });
          getCardListFun();
          setShowCardFields(false);
          setInitialLoading(false);
        } else {
          toast(res.message, {
            position: "top-center",
            hideProgressBar: true,
            type: "error",
          });
        }
      } catch (err) {
        consoleService("error in submitFun = ", err);
      }
    };

    const handleSubmit = async (event) => {
      event.preventDefault();

      setStripeLoading(true);

      if (!stripe || !elements) {
        return;
      }

      const cardNumberElement = elements.getElement(CardNumberElement);

      if (
        !isCardNumberValid ||
        !isExpiryCardValid ||
        !isCvcValid ||
        !name.trim()
      ) {
        return toast("Invalid card details.", {
          position: "top-center",
          hideProgressBar: true,
          type: "error",
        });
      }

      // Use your card Element with other Stripe.js APIs
      const { error, paymentMethod } = await stripe.createPaymentMethod({
        type: "card",
        card: cardNumberElement,
        billing_details: {
          name: name, // Attach the customer's name here
        },
      });

      if (error) {
        consoleService("[error]", error);
        setStripeLoading(false);
        return toast("Invalid card details.", {
          position: "top-center",
          hideProgressBar: true,
          type: "error",
        });
      } else {
        submitFun(paymentMethod.id);
      }
    };
    const inputStyle = {
      style: {
        base: {
          fontSize: "15px",
          padding: "20px",
          color: "black",
          fontFamily: "Helvetica Neue",
          "::placeholder": {
            color: "#595c5f",
          },
        },
        invalid: {
          color: "#EB0823",
        },
      },
    };
    return (
      <Form onSubmit={handleSubmit}>
        <Form.Group className="mb-4" controlId="exampleForm.ControlInput3">
          <Form.Label>Card Number</Form.Label>
          <CardNumberElement
            options={{
              ...inputStyle,
              placeholder: "Card Number",
            }}
            onChange={(value) => {
              setIscardValid(value.complete);
            }}
          />
        </Form.Group>

        <div className="row mb-4">
          <div className="col-md-8">
            <Form.Group className="mb-3" controlId="exampleForm.ControlInput3">
              <Form.Label>Valid Thru</Form.Label>
              <CardExpiryElement
                options={{
                  ...inputStyle,
                  placeholder: "Month/Year",
                }}
                onChange={(value) => {
                  setIsExpiryCardValid(value.complete);
                }}
              />
            </Form.Group>
          </div>
          <div className="col-md-4">
            <Form.Group className="mb-3" controlId="exampleForm.ControlInput3">
              <Form.Label>CVV</Form.Label>
              <CardCvcElement
                options={{
                  ...inputStyle,
                  placeholder: "Cvv",
                }}
                onChange={(value) => {
                  setIsCvcValid(value.complete);
                }}
              />
            </Form.Group>
          </div>
        </div>
        <Form.Group className="mb-3" controlId="exampleForm.ControlInput3">
          <Form.Label>Card Holder’s Name</Form.Label>
          <Form.Control
            type="text"
            placeholder="Name of card holder"
            value={name}
            style={{ paddingLeft: 0 }}
            onChange={(e) => {
              setName(e.target.value);
            }}
          />
        </Form.Group>
        <Button
          disabled={
            !stripe ||
            stripe_loading ||
            !isCardNumberValid ||
            !isExpiryCardValid ||
            !isCvcValid ||
            !name.trim()
          }
          type="submit"
          className={`btn btn-primary mt-3 ${
            stripe_loading ? "add_card_payment_setting_btn" : null
          } `}
        >
          {stripe_loading ? (
            <ReactLoader type="bubble-loop" bgColor={"white"} size={30} />
          ) : (
            "Add Card"
          )}
        </Button>
      </Form>
    );
  };

  const StripeProvider = () => {
    return (
      <Elements stripe={stripePromise}>
        <StripForm />
      </Elements>
    );
  };

  return (
    <React.Fragment>
      <div className="breadHidePhone">
        <BannerSection
          banner={Banner}
          name={"Home"}
          title={"Payment Settings"}
        />
      </div>
      <section className="py-5 useraccount bg-light_dash">
        <div className="container">
          <div className="row">
            <div
              className={`col-xl-3 col-md-4 ${
                filterHideShow ? "leftShow" : "leftHide"
              }`}
            >
              <TherapistSidebar />
            </div>

            <div className="col-xl-9 col-md-8 fulltabBox">
              <div className="filterBox">
                <Link className="filterIcon" onClick={sideBarHide}>
                  <FaAlignLeft />
                </Link>
              </div>
              {initial_loading && (
                <div className="dashboard-widg-bar d-block">
                  <div className="dashboard_body">
                    {cardList.length > 0 && (
                      <>
                        <h4 className="mb-4 ft-medium">Card details</h4>
                        {cardList.map((item, index) => {
                          return (
                            <div className="d-flex flex-row pb-3" key={index}>
                              <Form.Group controlId="exampleForm.ControlInput3">
                                {["radio"].map((type) => (
                                  <div
                                    key={`default-${type}`}
                                    className="p-1 px-0 me-2"
                                  >
                                    <Form.Check // prettier-ignore
                                      type={type}
                                      checked={item.default}
                                      id={item.id}
                                      label=""
                                      style={{ paddingLeft: 0 }}
                                      onClick={() => {
                                        if (item.default) return;
                                        set_default_card_fun(item.id);
                                      }}
                                    />
                                  </div>
                                ))}
                              </Form.Group>

                              <div
                                onClick={(e) => {
                                  e.stopPropagation();
                                  if (item.default) return;
                                  set_default_card_fun(item.id);
                                }}
                                className="rounded border d-flex w-100 p-3 align-items-center fontMedia cursor_pointer "
                              >
                                <p className="mb-0">
                                  <img
                                    src={getCardBrandIconPath(item.card.brand)}
                                    width={40}
                                    className="me-2"
                                    alt=""
                                  />
                                  <span style={{ marginLeft: 10 }}>
                                    {" "}
                                    {capitalizeFirstLetter(
                                      item.card.brand
                                    )}{" "}
                                    Debit Card
                                  </span>
                                </p>
                                <div className="ms-auto">
                                  **** **** **** {item.card.last4}
                                </div>

                                <Link
                                  onClick={(e) => {
                                    e.stopPropagation();
                                    delete_card_fun(item.id);
                                  }}
                                >
                                  Delete
                                </Link>
                              </div>
                            </div>
                          );
                        })}

                        <hr />
                      </>
                    )}
                    {showCardFields && <StripeProvider />}

                    {!showCardFields && initial_loading && (
                      <Button
                        as={Link}
                        variant="primary"
                        onClick={() => {
                          handle_add_card_fun();
                        }}
                      >
                        Add New Card
                      </Button>
                    )}
                  </div>
                </div>
              )}
            </div>
          </div>
        </div>
      </section>
    </React.Fragment>
  );
};

export default PaymentSettings;
